import { useNavigate } from 'react-router-dom'

interface AdminHeaderProps {
  onMenuToggle?: () => void
}

const AdminHeader = ({ onMenuToggle }: AdminHeaderProps) => {
  const navigate = useNavigate()

  const handleLogout = () => {
    localStorage.removeItem('adminAuth')
    navigate('/admin')
  }

  return (
    <header className="bg-gray-800 border-b border-gray-700 sticky top-0 z-40 shadow-lg">
      <div className="flex items-center justify-between h-16 px-4 md:px-6">
        {/* Logo and Title */}
        <div className="flex items-center space-x-3">
          {onMenuToggle && (
            <button
              onClick={onMenuToggle}
              className="md:hidden text-gray-300 hover:text-white mr-2"
              aria-label="Toggle menu"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          )}
          <img
            src={`${import.meta.env.BASE_URL}lmt-logo.png`}
            alt="LMT SEVA Logo"
            className="h-10 w-auto object-contain"
          />
          <div className="hidden sm:block">
            <div className="text-white font-bold text-lg">LMT SEVA</div>
            <div className="text-gray-400 text-xs">Admin Panel</div>
          </div>
        </div>

        {/* Right Side - User Info and Logout */}
        <div className="flex items-center space-x-2 md:space-x-4">
          <div className="hidden sm:block text-right">
            <div className="text-white font-semibold text-sm">Admin</div>
            <div className="text-gray-400 text-xs">admin@gmail.com</div>
          </div>
          <button
            onClick={handleLogout}
            className="px-3 md:px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-semibold transition-colors duration-300 flex items-center space-x-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            <span className="hidden sm:inline">Logout</span>
          </button>
        </div>
      </div>
    </header>
  )
}

export default AdminHeader

